// extracted by mini-css-extract-plugin
export default {"otpInputItem":"OtpInputItem_otpInputItem__T7UBg"};